export default () => {

  setTimeout(() => {
    const form = document.querySelectorAll("form");
    if (form.length) {
      const inputs = $(form)
        .find(
          '[type="text"], [type="tel"], [type="email"], [type="search"], textarea'
        )
        .get();
      $(inputs).on("click focus change input", function (e) {
        const id = this.id;
        const label = document.querySelector(`[for="${id}"]`);
        if (!$(label).hasClass("active")) {
          $(label).addClass("active");
          $(this).parent('.input__row').addClass("active");
        }
      });
      $(inputs).on("blur", function (e) {
        const id = this.id;
        const label = document.querySelector(`[for="${id}"]`);
        if ($(this).val() === "") {
          $(label).removeClass("active");
          $(this).parent('.input__row').removeClass("active");
        }
      });
    }
  }, 500);

  $(".call-popup").click(() => {
    $(".popup-callback").addClass('active');
  })
  $(".close-modal").click(() => {
    $(".popup").removeClass('active');
  });

  $(".category-filter__row--parent .category-filter__heading").click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
  });

  $(".category-filter__row--unique .category-filter__opener").click(function () {
    $(this).parents('.category-filter__row--unique').toggleClass('active');
  });

  $(".category-select__title").click(() => {
    $(".category-select").toggleClass('active');
  });

  if ($(window).width() < 1199) {
    const sidebarTop = $(".sidebar__top");
    const sidebarBottom = $(".sidebar__bottom");
    const cardPicture = $(".card__picture");
    $(".main-content").prepend(sidebarTop);
    $(".main-content").append(sidebarBottom);
    $(".card__top").prepend(cardPicture);

  }

  const touchElements = document.querySelectorAll(".touch-thing");
  touchElements.forEach(touchElement => {
    document.addEventListener("click", event => {
      if (event.target.closest(".touch-thing")) return;
      touchElement.classList.remove("active");
    });
  });

  const brandImageWidth = $(".brand__image").width();
  if (brandImageWidth) {
    $(".contacts-map").width(brandImageWidth);
  }
}


// WEBPACK FOOTER //
// app/scripts/components/main.js